export const escapeQuery = (value: String) => {
  return value
    .replace(/[<>]/g, ``)
    .replace(/([+\-=&|><!(){}[\]^"~*?:\\/])/g, '\\$1')
    .replace(/\s/g, '\\ ');
};
